'use client';
import {useCallback, useEffect, useState} from 'react';
import {usePathname, useRouter} from 'next/navigation';
import {switchTheme} from '@/app/utils/themeSwitch';
import {FOOTER_PAGES, HashMapPathName} from '@/app/config';
import {SRewardAnimation} from "@/app/_components/Coin/SRewardAnimation";
import useScroll from "@/app/hooks/useScroll";
import CoinLabel from "@/app/_components/Coin/CoinLabel";
import UserMgr from "@/Core/UserMgr";
import {RewardType} from "@/Core/Reward/RewardInfo";
import {useUser} from "@/app/context/UserContext";
import {useAppDispatch, useAppSelector} from "@/app/storeHooks";
import {selectAccountInfo, updateAccountInfo} from "@/app/(pages)/account/accountSlice";
import {getAccountInfoData} from "@/app/(pages)/account/accountAPI";
import styles from './Header.module.css'
import usePageLifecycle from "@/app/hooks/usePageLifecycle";
import LoginNetManager from "@/Core/Login/LoginNetManager";
import RouterMgr from "@/Core/RouterMgr";

export default function Header() {
    // const router = useRouter();
    const pathname = usePathname();
    const user = useUser();
    const account = useAppSelector(selectAccountInfo);
    const dispatch = useAppDispatch();
    const percent = account.info.userVipExp / account.info.userNextVipExp || 0;

    const [lastScrollY, setLastScrollY] = useState(0);
    const [shrink, setShrink] = useState(false);
    const [fade, setFade] = useState(false);
    
    useEffect(() => {
        SRewardAnimation.checkInitCoin();
        if (UserMgr.hasTokenOk(user.token)) {
            if (account.info.vipConfigList.vipLevels.length === 0) {
                getAccountInfoData(user).then(data => {
                    dispatch(updateAccountInfo(data))
                })
            }
        }
        return () => {};
    }, []);

    //更新用户啊基础数据
    const onUpdateUserBaseInfo = () => {
        if (UserMgr.hasTokenOk(user.token)) {
            LoginNetManager.Instance.UpdateUserBaseInfo()
        }
    }

    usePageLifecycle(useCallback(() => {
        onUpdateUserBaseInfo();
    }, []));

    useScroll(useCallback(() => {
        const currentY = window.scrollY || document.documentElement.scrollTop || document.body.scrollTop;
        if (currentY > 200) {
            setShrink(true);
        } else {
            setShrink(false);
        }
        if (currentY > lastScrollY) {
            setFade(true);
        } else {
            setFade(false);
        }
        setLastScrollY(currentY);
    }, []));

    useEffect(() => {
        updateRewardTypeUI();
    }, [user.rewardType]);

    const onClickSwitchBtn = () => {
        if (user.rewardType === RewardType.GC) {
            UserMgr.setRewardType(RewardType.SC);
        } else {
            UserMgr.setRewardType(RewardType.GC);
        }
        updateRewardTypeUI();
    };

    //更新用户
    const updateRewardTypeUI = () => {
        if (user.rewardType == RewardType.SC) {
            switchTheme('SC');
        }else{
            switchTheme('GC');
        }
    }

    // 避免在渲染期间直接返回 null
    if (!HashMapPathName(FOOTER_PAGES, pathname)) {
        return <></>;  // 代替返回 null，可以返回一个空的元素或不渲染任何东西
    }

    return (
        <>
            <header className={`${styles.header} ${fade ? styles.fade : ''} ${shrink ? styles.shrink : ''}`}>
                <div className={styles.header_wrapper}>
                    <img className={styles.header_logo} src="/img/logo.webp" alt=""/>

                    <div className={`${styles.header_gold_wrapper}`}>
                        <CoinLabel
                            type={user.rewardType}
                            isShowAdd={true}
                            click={()=>{
                                RouterMgr.shop();
                            }}
                        />
                    </div>

                    <div id="guideStep1_2" className={`${styles.hd_border} ${styles.header_switch_wrapper}`}>
                        <label className={`${styles.switch}`}>
                            <input
                                type="checkbox"
                                checked={user.rewardType === RewardType.SC}
                                id="switch-input"
                                onChange={onClickSwitchBtn}
                            />
                            <span className={`${styles.slider}`}></span>
                        </label>
                    </div>

                    <div className={`${styles.header_vip_wrapper}`} onClick={() => {
                        RouterMgr.push('/account/member')
                    }}>
                        <div
                            className={styles.vip_circle}
                            // @ts-ignore
                            style={{'--progress': `${percent}%`, '--last': '0%'}}             style={{'--progress': `${percent}%`, '--last': '0%'}}
                        >
                            <div className={`${styles.circle_num}`}></div>
                            <div className={`${styles.vip_content} h-v-center ft-900`}>
                                <img src="/img/img_vip.webp" alt=""/>
                                <p style={{fontSize: '.22rem'}}>{percent}%</p>
                            </div>
                        </div>
                    </div>
                </div>
            </header>

            {HashMapPathName(FOOTER_PAGES, pathname) && pathname !== "/" && <div className="header_panel"></div>}
        </>
    )
}
